import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const INTRO_PRICING_I18N_NAMESPACE = '@mc/next/experiments/prcng-338_v1'

export const i18nInstance = registerI18nResources({
  namespace: INTRO_PRICING_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
